export const PARTNER_EMAIL = 'partnerships@chisme.social';

export const PARTNER_REGISTER_URL = `mailto:${PARTNER_EMAIL}`;

export const PARTNERS_PAGE_URL = 'https://partners.chisme.social/';

export const PARTNERS_HOW_IT_WORKS_ID = 'como-funciona';

export const PARTNERS_IMAGES = {
  heroBusiness: '/images/business/Chisme-business.png',
} as const;
